/**
 * Leaves a placeholder at a dragged item's original position so the user can see where the
 * item came from while dragging.
 *
 * This rides on SortableJS's built-in origin clone: with removeCloneOnHide false, SortableJS
 * keeps a clone of the dragged item at its original position for the whole drag (normally
 * hidden with inline display:none) and removes it before the update/add/remove events fire,
 * so vuedraggable's index bookkeeping never sees it.  The .dragOriginPlaceholder class
 * (styled in Globals.scss) defeats the inline display:none to reveal the clone.
 *
 * Do not instead insert a custom placeholder element into a draggable container: vuedraggable
 * resolves drop positions by raw child index, and any extra child skews that mapping (e.g.
 * items dropped adjacent to their origin can jump to the end of the list).
 */

/** Bind to a draggable component via v-bind, together with @clone="StyleOriginPlaceholder". */
export const OriginPlaceholderOptions = {
	removeCloneOnHide: false
};

/** Bind to a draggable component's @clone event to style the origin clone as a placeholder. */
export function StyleOriginPlaceholder(evt)
{
	if (!evt.clone)
		return;
	evt.clone.classList.add("dragOriginPlaceholder");
	evt.clone.setAttribute("aria-hidden", "true");
}
